import { isProd } from "@configs/env";
import * as Sentry from "@sentry/react";
import { getDevFlags } from "@utils/dev-flags";
import { MemberModel } from "kz-ui-sdk";

const enableAutoCaptureSentry = isProd() || getDevFlags()?.enableSentry;

/**
 * Set the member context for Sentry reporting. Called from auth slice.
 * Kept in a small module so it does not pull sentry-init into the main bundle.
 */
export const setSentryMember = (member?: MemberModel | null) => {
  if (enableAutoCaptureSentry) {
    if (!member) {
      Sentry.setUser(null);
      return;
    }
    Sentry.setUser({
      id: member.id,
      username: member.phone + "-" + member.apiIdentifier,
    });
  }
};
